export default __webpack_public_path__ + "static/media/pump.782c1ae7.png";